import { SellingOffersNegotiations, SellingOffersNegotiationsData } from '../domain/sellingOffersNegotiations';
import { SellingOffersNegotiationsDTO, SellingOffersNegotiationsDataDTO } from '../dtos/sellingOffersNegotiationsDTO';

const mapNegotiationData = (dataDTO: SellingOffersNegotiationsDataDTO): SellingOffersNegotiationsData => {
  const { id, lastAction, negotiationStatus, buyer, hasBestOffer } = dataDTO;
  return {
    id: id,
    negotiationStatus: {
      callerMessage: negotiationStatus.callerMessage,
      callerSubMessage: negotiationStatus.callerSubMessage,
      isAccepted: negotiationStatus.isAccepted,
      isClosed: negotiationStatus.isClosed,
      callerRemainingActionsNumber: negotiationStatus.callerRemainingActionsNumber,
      callerPossibleActions: negotiationStatus.callerPossibleActions,
    },
    lastAction: {
      originator: lastAction.originator,
      offerFormatted: lastAction.offerFormatted,
      offerSellerEarningsFormatted: lastAction.offerSellerEarningsFormatted,
      actionNote: lastAction.actionNote,
      action: lastAction.action,
    },
    buyer: {
      id: buyer.id,
      name: buyer.name,
      picturePath: buyer.picturePath,
    },
    hasBestOffer: hasBestOffer,
  };
};

export const getMappedSellingOffersNegotiationsResponse = (
  dto: SellingOffersNegotiationsDTO,
): SellingOffersNegotiations => {
  return {
    data: dto.data.map(mapNegotiationData),
    meta: {
      limit: dto.meta.limit,
      offset: dto.meta.offset,
      count: dto.meta.count,
    },
  };
};
